module.exports = __webpack_public_path__ + "static/media/Group68.008c9bb6.svg";